import type { WelcomePost } from '../types'
import { getCommonWelcomePostPayload } from './getCommonWelcomePostPayload'

export const getImageWelcomePostPayload = async (welcomePost: WelcomePost) => {
  return {
    type: 'Image',
    attributes: getCommonWelcomePostPayload(welcomePost),
    imageResourceId: welcomePost.imageResourceId,
  }
}
